import { useActivity } from 'modules/core/lib/activities/activity'
import { ActivityComponent } from 'modules/core/lib/activities/types'

import { DefaultComplianceSettingsDeleteModal } from './DefaultComplianceSettingsDeleteModal'

type DefaultComplianceSettingsCreateActivityProps = {
  refetchQuery: string
  defaultComplianceExtraFieldSettingId: string
}

export const DefaultComplianceSettingsDeleteActivity: ActivityComponent<
  DefaultComplianceSettingsCreateActivityProps
> = (data) => {
  const { open, closeActivity } = useActivity()

  return (
    <DefaultComplianceSettingsDeleteModal
      isOpen={open}
      onClose={closeActivity}
      refetchQuery={data.refetchQuery}
      defaultComplianceExtraFieldSettingId={Number(data.defaultComplianceExtraFieldSettingId)}
    />
  )
}
